import React from 'react';

import { Tabs } from 'components/DesignSystem/Tabs';
import { useSimulatedActivitiesFiltersStore } from 'components/widgets/ScheduleSimulation/components/SimulatedActivitiesTable/SimulatedActivitiesFilter/simulatedActivitiesFilter.store';
import {
    activitiesTabActivityTypeInitialOptions,
    statusOptions,
    wbsTabActivityTypeInitialOptions,
} from 'components/widgets/ScheduleSimulation/components/SimulatedActivitiesTable/SimulatedActivitiesFilter/simulatedActivitiesFilter.utils';
import {
    TabKeys,
    generateTabs,
} from 'components/widgets/ScheduleSimulation/components/SimulatedActivitiesTable/SimulatedActivityTabs/simulatedActivitiesTabs.utils';

export const SimulatedActivitiesTabs = () => {
    const { activeTab, update: updateFilters } = useSimulatedActivitiesFiltersStore();

    const tabs = generateTabs();
    const handleActiveTab = (tab: TabKeys) => {
        if (tab === 'activities') {
            updateFilters({
                activeTab: tab,
                search: '',
                activityTypeFilter: activitiesTabActivityTypeInitialOptions,
                statusFilter: statusOptions,
            });
        } else if (tab === 'wbs') {
            updateFilters({
                activityTypeFilter: wbsTabActivityTypeInitialOptions,
                statusFilter: [],
                search: '',
                isCriticalPathFilter: false,
                isCriticalPathChangedFilter: false,
                activeTab: tab,
            });
        }
    };

    return <Tabs tabs={tabs} value={activeTab} onChange={(value) => handleActiveTab(value as TabKeys)} />;
};
